import { useEffect, useState } from "react";
import { AnimatedPage } from "../../../../components";
import { Card, CardContent } from "../../../../components/ui/card";
import { useToast } from "../../../../hooks/use-toast";
import { config } from "../../../../utils/config";
import { EditDialog } from "./components/edit-dialog";
import { ResultsTable } from "./components/results-table";
import { SearchForm } from "./components/search-form";
import { useDocumentEdit } from "./hooks/use-document-edit";

export default function DocumentEdit() {
  const fundName = `xama_${config.stage}`;
  const { toast } = useToast();

  const {
    cadastroData,
    allOps,
    searchForm,
    setSearchForm,
    editingDocument,
    editForm,
    setEditForm,
    handleSearch,
    handleEdit,
    handleUpdate,
    handleCancelEdit,
    isSearching,
    isUpdating,
  } = useDocumentEdit({ fundName });

  const validateSearchForm = () => {
    if (!searchForm.telefone.trim() && !searchForm.cpfCnpj.trim()) {
      toast({
        title: "Campos obrigatórios",
        description: "Informe pelo menos um campo: Telefone ou CPF/CNPJ",
        variant: "destructive",
      });
      return false;
    }
    return true;
  };

  const handleSearchClick = () => {
    if (!validateSearchForm()) return;
    handleSearch();
  };

  const handleSaveClick = () => {
    handleUpdate();
    toast({
      title: "Cadastro atualizado",
      description: "As alterações foram salvas com sucesso.",
    });
  };

  return (
    <AnimatedPage className="p-6">
      <div className="mb-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold text-foreground">
              Editar Documentos
            </h1>
            <p className="text-muted-foreground mt-1">
              Buscar e editar cadastros de documentos
            </p>
          </div>
        </div>
      </div>

      <div className="space-y-6">
          <SearchForm
            searchForm={searchForm}
            onSearchFormChange={setSearchForm}
            onSearch={handleSearchClick}
            isSearching={isSearching}
            fundName={fundName}
          />

          <ResultsTable documents={cadastroData} onEdit={handleEdit} />

          <EditDialog
            open={!!editingDocument}
            document={editingDocument}
            formData={editForm}
            allOps={allOps}
            onFormChange={setEditForm}
            onSave={handleSaveClick}
            onCancel={handleCancelEdit}
            isSaving={isUpdating}
          />
        </div>
    </AnimatedPage>
  );
}
